import DashView from './components/Dash.vue'
// import LoginView from './components/Login.vue'
import TokenValidateView from './components/tokenvalidate.vue'
import NotFoundView from './components/404.vue'
import ConfirmView from './components/confirmpage.vue'
import PasswordResetView from './components/passwordreset.vue'

// Import Views - Dash
import DashboardView from './components/views/Dashboard.vue'
import CreateMerchantView from './components/views/merchant/createmerchant.vue'
import ApproveMerchantRequests from './components/views/merchant/approvemerchant.vue'
import ViewMerchants from './components/views/merchant/viewmerchants.vue'
import ViewStatements from './components/views/transaction/viewposstatements.vue'
import ViewStatementsToday from './components/views/transaction/viewposstatementstoday.vue'
import STKPushTransactions from './components/views/transaction/stkpushtransactions.vue'
import ConfigureMerchant from './components/views/merchant/merchantconfig.vue'
import MerchantCreationRequests from './components/views/merchant/merchantrequests.vue'
import ApproveStore from './components/views/store/approvestore.vue'
import CreateInternalUserView from './components/views/user/createinternaluser.vue'
import ApproveInternalUserView from './components/views/user/approveinternalusers.vue'
import ViewInternalUserView from './components/views/user/viewinternalusers.vue'
import ViewUserLoginHistory from './components/views/user/viewuserloginhistory.vue'
import CreateExternalUserView from './components/views/user/createexternaluser.vue'
import ApproveExternalUserView from './components/views/user/approveexternalusers.vue'
import ViewExternalUserView from './components/views/user/viewexternalusers.vue'
import UserCreationRequestsView from './components/views/user/userrequests.vue'
import CreatePermissionView from './components/views/createpermission.vue'
import ViewPermissionView from './components/views/viewpermissions.vue'
import CreateRoleView from './components/views/createrole.vue'
import ViewRoleView from './components/views/viewrole.vue'
import ApproveRoleView from './components/views/approverole.vue'
import InternalUserUploadFormView from './components/views/file/uploadprocessingresult.vue'
import OriginatorViewUploadResults from './components/views/file/originatorprocessingresults.vue'
import UpdatePasswordView from './components/views/user/updatepassword.vue'
import PasswordResetRequest from './components/passwordresetrequest.vue'
import PosTransactionsView from './components/views/transaction/postransactions.vue'
import MpesaTransactionsView from './components/views/transaction/mpesatransactions.vue'
import SystemStatusView from './components/views/admin/systemstatus.vue'
import TokenNotification from './components/views/admin/usertokennotifications.vue'
import BulkUpload from './components/views/merchant/BulkUpload.vue'
import BulkUploadApprove from './components/views/merchant/ApproveBulkUpload.vue'

// Routes
const routes = [
  {
    path: '/login',
    // component: LoginView
    component: () => import(/* webpackChunkName: "login" */ './components/Login.vue')
  },
  {
    path: '/:id/otp-validate',
    component: TokenValidateView
  },
  {
    path: '/confirm',
    component: ConfirmView
  },
  {
    path: '/user/resetpassword',
    component: PasswordResetRequest
  },
  {
    path: '/reset',
    component: PasswordResetView
  },
  {
    path: '/',
    component: DashView,
    children: [
      {
        path: 'dashboard',
        alias: '',
        component: DashboardView,
        name: 'Dashboard',
        meta: {description: 'Home', requiresAuth: true}
      },
      {
        path: '/user/internal/create',
        component: CreateInternalUserView,
        name: 'Create Internal User',
        meta: {description: ''}
      },
      {
        path: '/user/internal/approve',
        component: ApproveInternalUserView,
        name: 'Approve Internal User',
        meta: {description: ''}
      },
      {
        path: '/user/internal/view',
        component: ViewInternalUserView,
        name: 'Internal Users',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/user/login-history-info',
        component: ViewUserLoginHistory,
        name: 'User Login History',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/user/external/create',
        component: CreateExternalUserView,
        name: 'Create External User',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/merchant/users/approve',
        component: ApproveExternalUserView,
        name: 'Approve External User',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/user/external/view',
        component: ViewExternalUserView,
        name: 'External Users',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/user/requests',
        component: UserCreationRequestsView,
        name: 'Creation Requests',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/admin/createrole',
        component: CreateRoleView,
        name: 'Create Roles',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/admin/viewroles',
        component: ViewRoleView,
        name: 'View Roles',
        meta: {description: 'View Roles', requiresAuth: true}
      },
      {
        path: '/admin/approverole',
        component: ApproveRoleView,
        name: 'Approve Roles',
        meta: {description: 'Approve Roles', requiresAuth: true}
      },
      {
        path: '/permission/create',
        component: CreatePermissionView,
        name: 'Create Permissions',
        meta: {description: 'Create  Permission', requiresAuth: true}
      },
      {
        path: '/permission/view',
        component: ViewPermissionView,
        name: 'View Permissions',
        meta: {description: 'List of Permissions', requiresAuth: true}
      },
      {
        path: '/admin/systemstatus',
        component: SystemStatusView,
        name: 'System Status',
        meta: {description: 'System Status', requiresAuth: true}
      },
      {
        path: '/admin/tokennotification',
        component: TokenNotification,
        name: 'Notifications',
        meta: {description: 'Notifications', requiresAuth: true}
      },
      {
        path: '/merchant/create',
        component: CreateMerchantView,
        name: 'Create Merchant',
        meta: {description: 'Create Merchant', requiresAuth: true}
      },
      {
        path: '/merchant/approve',
        component: ApproveMerchantRequests,
        name: 'Approve Merchant',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/merchant/view',
        component: ViewMerchants,
        name: 'View Merchants',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/merchant/pos_statement',
        component: ViewStatements,
        name: 'View Card Transactions Statement',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/merchant/pos_statement_today',
        component: ViewStatementsToday,
        name: 'View Card Transactions Statement',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/merchant/stkpush_transaction',
        component: STKPushTransactions,
        name: 'View STK Push Transactions',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/merchant/:id/configure',
        component: ConfigureMerchant,
        name: 'Configure Merchant',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/merchant/stores/approve',
        component: ApproveStore,
        name: 'Approve Store',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/merchant/requests',
        component: MerchantCreationRequests,
        name: 'Merchant Requests',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/bulk_upload',
        component: BulkUpload,
        name: 'Bulk Upload',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/bulk_upload_approve',
        component: BulkUploadApprove,
        name: 'Bulk Upload Approve',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/file/upload/result',
        component: InternalUserUploadFormView,
        name: 'Upload Proccessing Results',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/file/view/results',
        component: OriginatorViewUploadResults,
        name: 'Processing Result',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/user/updatepassword',
        component: UpdatePasswordView,
        name: 'Update Password',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/merchant/transactions',
        component: PosTransactionsView,
        name: 'View Transactions',
        meta: {description: '', requiresAuth: true}
      },
      {
        path: '/merchant/mpesa_transaction',
        component: MpesaTransactionsView,
        name: 'Mpesa Transactions',
        meta: {description: '', requiresAuth: true}
      }
    ]
  }, {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js